export default "__VITE_ASSET__0f18e5ce__"